import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import GuideDetail from "./pages/GuideDetail";
import Success from "./pages/Success";
import FreeGuide from "./pages/FreeGuide";
import CategoryPage from "./pages/CategoryPage";
import BrowseGuides from "./pages/BrowseGuides";
import BundlesPage from "./pages/BundlesPage";
import BundleDetail from "./pages/BundleDetail";
import Support from "./pages/Support";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import TrendingTemplates from "./pages/TrendingTemplates";
import BundleBuilder from "./pages/BundleBuilder";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminResetPassword from "./pages/AdminResetPassword";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  useEffect(() => {
    const testBackend = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    testBackend();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/browse" element={<BrowseGuides />} />
          <Route path="/bundles" element={<BundlesPage />} />
          <Route path="/bundle/:id" element={<BundleDetail />} />
          <Route path="/support" element={<Support />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="/guide/:id" element={<GuideDetail />} />
          <Route path="/success" element={<Success />} />
          <Route path="/free-guide" element={<FreeGuide />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/trending" element={<TrendingTemplates />} />
          <Route path="/build-bundle" element={<BundleBuilder />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/reset-password" element={<AdminResetPassword />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;